{
  "columns": {
    "item": "Card",
    "consignor": "Consignor",
    "sold": "Sold",
    "sold_price": "Sold for",
    "commission": "Shop commission",
    "card_fee": "Card fee share",
    "proceeds": "Consignor gets",
    "paid": "Paid",
    "outstanding": "Still to pay",
    "status": "State"
  },
  "channel": {
    "web": "Website",
    "pos": "Shop register"
  },
  "settlement_status": {
    "not_applicable": "Nothing to pay",
    "awaiting_payout": "Waiting for payment",
    "processing": "Being paid",
    "adjusted": "Changed — check",
    "partially_paid": "Partly paid",
    "paid": "Paid"
  },
  "payout_status": {
    "draft": "Draft",
    "processing": "Waiting for the transfer",
    "paid": "Paid",
    "cancelled": "Cancelled"
  },
  "method": {
    "bank_transfer_manual": "Bank transfer",
    "cash": "Cash at the shop",
    "store_credit": "Store credit"
  },
  "method_hint": {
    "bank_transfer_manual": "You transfer at the bank; record it here.",
    "cash": "Paid from the register; they sign the slip.",
    "store_credit": "Credit for the shop, valid up to 6 months."
  },
  "codes": {
    "service_fee": "Shop commission",
    "payment_fee": "Card fee share",
    "shipping": "Shipping",
    "grading_fee": "Grading fee",
    "other": "Other",
    "refund_reversal": "Refund"
  },
  "skip": {
    "below_minimum": "less than their minimum payout",
    "nothing_due": "nothing to pay",
    "carry_exceeds_outstanding": "they owe the shop more than is waiting",
    "payout_in_progress": "a payout is already being made",
    "consignor_closed": "the consignor is closed",
    "no_payout_destination": "no bank account yet"
  },
  "settlements": {
    "intro": "Every sold consigned card: what it sold for, what the shop keeps and what the consignor gets. The numbers come from the shop system.",
    "pay": "Pay consignors",
    "only_of": "Only the sales of",
    "everyone": "Everyone",
    "view_awaiting": "Waiting for payment",
    "view_adjusted": "Changed — check",
    "month": "Month sold",
    "all_months": "All months",
    "custom_range": "{{from}} – {{to}}"
  },
  "deductions": {
    "title": "Sale",
    "intro": "What the consignor gets for this card.",
    "load_failed": "This sale could not be loaded.",
    "caption": "How the consignor's money is worked out",
    "refunded": "Refunded to the customer",
    "needs_review": "Something changed after the sale (a refund or a price) — check the numbers before paying.",
    "add_title": "Take off shipping, grading or other costs",
    "kind": "What for",
    "amount": "Amount",
    "note": "Note for the consignor",
    "add": "Take this off",
    "add_hint": "The consignor sees this line on their 精算書.",
    "remove": "Remove {{label}}",
    "remove_title": "Remove this cost?",
    "locked": "This sale is paid (or final) — its costs cannot change any more.",
    "recalculate": "Calculate again with today's commission",
    "recalculated": "Calculated again.",
    "consequence": "The shop system works out what the consignor gets again.",
    "confirm": "Save",
    "saved": "Saved — the consignor's money was worked out again.",
    "payments": "Paid with"
  },
  "wizard": {
    "title": "Pay consignors",
    "intro": "Who, which sales, how. The money is paid outside the shop system (bank or cash) — here you record it.",
    "load_failed": "Could not work out who is owed.",
    "steps": "Steps",
    "step_who": "Who",
    "step_sales": "Which sales",
    "step_how": "How",
    "who_title": "Who gets paid",
    "nobody": "Nobody is owed money right now.",
    "nobody_body": "Sold consigned cards appear here once the sale is settled.",
    "sales_one": "{{count}} sale",
    "sales_other": "{{count}} sales",
    "skipped_one": "{{count}} person is not paid this time",
    "skipped_other": "{{count}} people are not paid this time",
    "include_below": "Also pay people below their minimum payout",
    "sales_title": "Which sales",
    "carry": "Owed to the shop, taken off",
    "pays": "Pays",
    "amount_on_save": "The amount is worked out when you save",
    "how_title": "How it is paid",
    "method": "Payment",
    "transfer_when": "The bank transfer",
    "paid_later": "I will transfer now — make the transfer file, record it after",
    "paid_now": "Already transferred",
    "paid_on": "Paid on",
    "paid_on_hint": "The day the money left (Japan time).",
    "reference": "Transfer reference",
    "reference_hint": "From the bank's confirmation (振込受付番号).",
    "slip": "Transfer slip (optional)",
    "cash_location": "Register at",
    "cash_location_hint": "The cash comes from the open register of this shop.",
    "signature": "Photo of the signed receipt",
    "store_credit_note": "Store credit can be used in the shop for up to 6 months (資金決済法).",
    "no_bank_file": "The transfer file is made when every sale of everyone chosen is paid together.",
    "summary": "Summary",
    "total": "Total",
    "next": "Next",
    "back": "Back",
    "create": "Make the payouts",
    "record_paid": "Record as paid",
    "confirm_title": "Make the payouts?",
    "confirm_paid_title": "Record the payment?",
    "confirm_later_one": "{{count}} payout will wait for your bank transfer.",
    "confirm_later_other": "{{count}} payouts will wait for your bank transfer.",
    "confirm_paid_one": "The consignor is told and gets their 精算書.",
    "confirm_paid_other": "The {{count}} consignors are told and get their 精算書.",
    "done_one": "{{count}} payout made.",
    "done_other": "{{count}} payouts made.",
    "some_failed": "Some people could not be paid:",
    "to_list": "All payouts"
  },
  "bank_file": {
    "download": "Download the transfer file",
    "saved": "Transfer file saved — open it in your bank's software or Excel.",
    "next_steps": "Upload the file at the bank, make the transfers, then record each payout as paid."
  },
  "statement": {
    "open": "精算書",
    "making": "Making the 精算書…",
    "failed": "The 精算書 could not be made yet — the shop system tries again.",
    "mailed": "The consignor gets their 精算書 by e-mail and in the portal."
  },
  "payouts": {
    "intro": "Every payment to consignors. Payments waiting for the bank transfer are recorded here after the money left.",
    "pay": "Pay consignors",
    "reference": "Number",
    "amount": "Amount",
    "method": "How",
    "paid_on": "Paid on",
    "statement": "精算書",
    "statement_ready": "Ready",
    "view_processing": "Waiting for the transfer"
  },
  "detail": {
    "title": "Payout",
    "load_failed": "This payout could not be loaded.",
    "paid_on": "Paid on",
    "run": "Run {{reference}}",
    "sales": "Sales in this payout",
    "this_payout": "This payout",
    "record_title": "Record the bank transfer",
    "record_intro": "After the money left the bank: the date and the transfer reference.",
    "record": "Record as paid",
    "record_consequence": "The consignor is told and gets their 精算書.",
    "paid_done": "Recorded as paid.",
    "cancel": "Cancel this payout",
    "cancel_title": "Cancel this payout?",
    "cancel_consequence": "Nothing was paid; the sales wait for the next payout.",
    "cancelled": "Payout cancelled."
  },
  "problems": {
    "reference": "Type the transfer reference.",
    "signature": "Add the photo of the signed receipt."
  }
}
